import {
    codeBlockPlugin,
    codeMirrorPlugin,
    headingsPlugin,
    listsPlugin,
    quotePlugin,
    tablePlugin,
    thematicBreakPlugin,
} from "@mdxeditor/editor";
import { citationsPlugin } from "./Citation";
import { listStartPlugin } from "./listStartPlugin";

/** The content plugins of the artifact / rich-text editor, shared with its round-trip test. */
export const richTextContentPlugins = () => [
    headingsPlugin(),
    listsPlugin(),
    listStartPlugin(),
    quotePlugin(),
    thematicBreakPlugin(),
    citationsPlugin(),
    tablePlugin({ tablePipeAlign: false, tableCellPadding: false }),
    codeBlockPlugin({ defaultCodeBlockLanguage: "" }),
    codeMirrorPlugin({ codeBlockLanguages: { "": "Plain Text" } }),
];
